<template>
  <div>
    <vxe-card>
      <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
    </vxe-card>
    <approval-config ref="approvalConfig" :flow-types="flowTypes" :roles="roles"/>
    <inventory-state-config ref="stateConfig" :inventory-states="inventoryStates" :owners="owners" :warehouses="warehouses"/>
    <order-type-switch-config ref="typeConfig" :number-types="numberTypes"/>
  </div>
</template>

<script>
import ApprovalConfig from '@/views/basedata/orderType/ApprovalConfig.vue'
import InventoryStateConfig from '@/views/basedata/orderType/InventoryStateConfig.vue'
import OrderTypeSwitchConfig from '@/views/basedata/orderType/OrderTypeSwitchConfig.vue'

export default {
  name: 'OrderTypeExtra',
  components: { ApprovalConfig, InventoryStateConfig, OrderTypeSwitchConfig },
  props: {
    inventoryStates: { type: Array, default: () => [] },
    numberTypes: { type: Array, default: () => [] },
    warehouses: { type: Array, default: () => [] },
    owners: { type: Array, default: () => [] },
    roles: { type: Array, default: () => [] },
    flowTypes: { type: Array, default: () => [] }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(type) {
      this.$refs.approvalConfig.refresh(type)
      this.$refs.stateConfig.refresh(type)
      this.$refs.typeConfig.refresh(type)
    }
  }
}
</script>